import React from 'react';
import '../UnauthentifiedPages.scss';
import { Button, Container, Typography, Input, Spacing, Separator } from '@design-system';
import { useResetPasswordPageVM } from './useResetPasswordPageVM';
import Logo from '@assets/images/logo/logo-cosem.svg?react';
import { Formik } from 'formik';
import { ResetPasswordRequest } from '@services/core/auth/auth.types';
import { useNavigate } from 'react-router-dom';

export const ResetPasswordPage: React.FC = () => {
    const { handleSubmit, isLoading, token } = useResetPasswordPageVM();
    const navigate = useNavigate();

    return (
        <Container className="unauthentified-page">
            <Logo />
            <Spacing size="x-large" />
            <Separator fullWidth />
            <Spacing size="large" />
            <Typography intrinsic="p" className="welcome-back">
                Réinitialiser mon mot de passe
            </Typography>
            <Spacing size="x-large" />
            <Typography intrinsic="h1">Nouveau mot de passe</Typography>
            <Spacing size="large" />
            <Formik
                initialValues={{
                    token: token || '',
                    password: '',
                    confirm_password: ''
                }}
                onSubmit={async (values: ResetPasswordRequest) => {
                    await handleSubmit(values);
                }}
            >
                {({ values, handleChange, handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <Input
                                label="Mot de passe"
                                placeholder="Mot de passe"
                                name="password"
                                value={values.password}
                                onChange={handleChange}
                            />
                            <Spacing size="small-medium" />
                            <Input
                                label="Confirmer le mot de passe"
                                placeholder="Confirmer le mot de passe"
                                name="confirm_password"
                                value={values.confirm_password}
                                onChange={handleChange}
                                type="password"
                            />
                            <Spacing />
                            <Button variant="primary" disabled={isLoading}>
                                <Typography intrinsic="p">Réinitialiser mon mot de passe</Typography>
                            </Button>
                        </form>
                    );
                }}
            </Formik>
            <Spacing size="x-large" />
            <Typography intrinsic="p" variant="p2" color="grey1" className="back-to-login" onClick={() => navigate('/login')}>
                Retour à la page de connexion
            </Typography>
        </Container>
    );
};
